// Deckbuilder JavaScript Functionality

document.addEventListener('DOMContentLoaded', function() {
  const deckInput = document.getElementById('deck-input');
  const searchBtn = document.getElementById('search-deck');
  const clearBtn = document.getElementById('clear-deck');
  const resultsSection = document.getElementById('results-section');
  const resultsGrid = document.getElementById('results-grid');
  const loadingIndicator = document.getElementById('loading-indicator');
  const addAllBtn = document.getElementById('add-all-to-cart');
  const missingCardsSection = document.getElementById('missing-cards');
  const missingList = document.getElementById('missing-list');
  const backBtn = document.getElementById('back-to-deckbuilder');
  const inputSection = document.querySelector('.deckbuilder-input-section');
  const vendorSelect = document.getElementById('vendor-select');

  // Stats elements
  const lineCount = document.getElementById('line-count');
  const cardCount = document.getElementById('card-count');
  const foundCount = document.getElementById('found-count');
  const missingCount = document.getElementById('missing-count');
  const totalPrice = document.getElementById('total-price');

  let searchResults = [];
  let missingCards = [];
  let totalCost = 0;

  // Check for data from mini deckbuilder
  const urlParams = new URLSearchParams(window.location.search);
  const fromMini = urlParams.get('from-mini');
  const quickSearch = urlParams.get('quick-search');

  if (fromMini || quickSearch) {
    const miniData = sessionStorage.getItem('miniDeckbuilderData');
    if (miniData) {
      try {
        const data = JSON.parse(miniData);

        // Populate the deck input
        if (data.cards) {
          deckInput.value = data.cards;
        }

        // Set collection if provided
        if (data.collection && vendorSelect) {
          vendorSelect.value = data.collection;
        }

        // Clear the session storage
        sessionStorage.removeItem('miniDeckbuilderData');

        // Update stats
        updateInputStats();

        // If quick search, automatically trigger search
        if (quickSearch) {
          setTimeout(() => {
            searchBtn.click();
          }, 100);
        } else {
          // Show a notification that data was transferred
          const notification = document.createElement('div');
          notification.className = 'transfer-notification';
          notification.innerHTML = `
            <div class="notification-content">
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span>Deck data transferred from Quick Check!</span>
            </div>
          `;
          document.body.appendChild(notification);

          setTimeout(() => {
            notification.classList.add('show');
          }, 100);

          setTimeout(() => {
            notification.classList.remove('show');
            setTimeout(() => {
              notification.remove();
            }, 300);
          }, 3000);
        }
      } catch (e) {
        console.error('Error parsing mini deckbuilder data:', e);
      }
    }
  }

  // Update input stats in real-time
  deckInput.addEventListener('input', updateInputStats);

  function updateInputStats() {
    const lines = deckInput.value.trim().split('\n').filter(line => line.trim());
    const totalCards = lines.reduce((sum, line) => {
      const match = line.trim().match(/^(\d+)\s+(.+)$/);
      return sum + (match ? parseInt(match[1]) : 1); // Default to 1 if no quantity found
    }, 0);

    lineCount.textContent = `${lines.length} lines`;
    cardCount.textContent = `${totalCards} cards total`;
  }

  // Clear deck functionality
  clearBtn.addEventListener('click', function() {
    deckInput.value = '';
    updateInputStats();
    hideResults();
  });

  // Search deck functionality
  searchBtn.addEventListener('click', function() {
    const deckList = parseDeckList(deckInput.value);
    if (deckList.length === 0) {
      alert('Please enter a deck list first!');
      return;
    }
    searchCards(deckList);
  });

  // Add all to cart functionality
  addAllBtn.addEventListener('click', function() {
    addAllFoundCardsToCart();
  });

  // Back to deckbuilder functionality
  backBtn.addEventListener('click', function() {
    showInputSection();
    hideResults();
  });

  function parseDeckList(input) {
    const lines = input.trim().split('\n').filter(line => line.trim());
    const deckList = [];

    lines.forEach(line => {
      const trimmed = line.trim();
      // First try to match with quantity
      const matchWithQty = trimmed.match(/^(\d+)\s+(.+)$/);
      
      if (matchWithQty) {
        const quantity = parseInt(matchWithQty[1]);
        const cardName = matchWithQty[2].trim();
        deckList.push({ quantity, cardName, originalLine: trimmed });
      } else {
        // No quantity found, default to 1
        const cardName = trimmed;
        deckList.push({ quantity: 1, cardName, originalLine: trimmed });
      }
    });

    return deckList;
  }

  async function searchCards(deckList) {
    showLoading();
    searchResults = [];
    missingCards = [];
    totalCost = 0;

    try {
      for (const card of deckList) {
        const result = await searchSingleCard(card.cardName, card.quantity);
        if (result.found) {
          searchResults.push({
            ...result,
            quantity: card.quantity,
            originalLine: card.originalLine,
            originalCardName: card.cardName
          });
          totalCost += result.price * card.quantity;
        } else {
          missingCards.push({
            cardName: card.cardName,
            quantity: card.quantity,
            originalLine: card.originalLine
          });
        }
      }

      displayResults();
    } catch (error) {
      console.error('Search error:', error);
      alert('Error searching for cards. Please try again.');
    } finally {
      hideLoading();
    }
  }

  async function searchSingleCard(cardName, quantity) {
    try {
      const vendorSelect = document.getElementById('vendor-select');
      const selectedCollection = vendorSelect.value;
      
      let searchQuery = encodeURIComponent(cardName);
      let searchUrl;
      
      if (selectedCollection) {
        // Use global search but filter by collection
        searchUrl = `/search/suggest.json?q=${searchQuery}&resources[type]=product&resources[limit]=50`;
      } else {
        // Use global search API
        searchUrl = `/search/suggest.json?q=${searchQuery}&resources[type]=product&resources[limit]=10`;
      }

      const response = await fetch(searchUrl);
      const data = await response.json();

      if (data.resources && data.resources.results && data.resources.results.products && data.resources.results.products.length > 0) {
        let products = data.resources.results.products;
        
        // If collection is selected, filter products by collection
        if (selectedCollection) {
          // Filter by checking if product URL contains collection handle
          products = products.filter(product => {
            // Check if product belongs to the selected collection
            return product.url && product.url.includes(`/collections/${selectedCollection}/`);
          });
          
          // If no products found in collection, try alternative filtering
          if (products.length === 0) {
            // Try searching with collection name in query
            const collectionName = getCollectionDisplayName(selectedCollection);
            const collectionSearchUrl = `/search/suggest.json?q=${searchQuery}+${encodeURIComponent(collectionName)}&resources[type]=product&resources[limit]=20`;
            
            try {
              const collectionResponse = await fetch(collectionSearchUrl);
              const collectionData = await collectionResponse.json();
              if (collectionData.resources && collectionData.resources.results && collectionData.resources.results.products) {
                products = collectionData.resources.results.products;
              }
            } catch (e) {
              console.log('Collection search fallback failed, using original results');
              products = data.resources.results.products;
            }
          }
        }
        
        if (products.length > 0) {
          // Find the best match
          const bestMatch = findBestMatch(products, cardName);
          
          if (bestMatch) {
            // Get product details
            const productResponse = await fetch(`/products/${bestMatch.handle}.js`);
            const productData = await productResponse.json();
            
            // Find available variant
            const availableVariant = productData.variants.find(v => v.available);
            
            if (availableVariant) {
              return {
                found: true,
                product: productData,
                variant: availableVariant,
                title: productData.title,
                price: availableVariant.price / 100, // Convert from cents
                image: productData.featured_image,
                url: `/products/${productData.handle}`,
                variantId: availableVariant.id
              };
            }
          }
        }
      }

      return { found: false, cardName };
    } catch (error) {
      console.error('Error searching for card:', cardName, error);
      return { found: false, cardName };
    }
  }

  function getCollectionDisplayName(handle) {
    const collectionNames = {
      'magic-the-gathering': 'Magic The Gathering',
      'pokemon': 'Pokemon',
      'flesh-blood': 'Flesh Blood',
      'grand-archive': 'Grand Archive',
      'star-wars-unlimited': 'Star Wars',
      'one-piece': 'One Piece',
      'lorcana': 'Lorcana',
      'hololive': 'Hololive',
      'godzilla': 'Godzilla',
      'topps': 'Topps',
      'sorcery': 'Sorcery'
    };
    return collectionNames[handle] || handle;
  }

  function findBestMatchFromProducts(products, searchTerm) {
    const searchLower = searchTerm.toLowerCase();
    
    // Exact match first
    let exactMatch = products.find(p => p.title.toLowerCase() === searchLower);
    if (exactMatch) return exactMatch;

    // Contains match
    let containsMatch = products.find(p => p.title.toLowerCase().includes(searchLower));
    if (containsMatch) return containsMatch;

    // Word match
    const searchWords = searchLower.split(' ');
    let wordMatch = products.find(p => {
      const titleLower = p.title.toLowerCase();
      return searchWords.every(word => titleLower.includes(word));
    });
    if (wordMatch) return wordMatch;

    // Return first result as fallback
    return products[0];
  }

  function findBestMatch(products, searchTerm) {
    const searchLower = searchTerm.toLowerCase();
    
    // Exact match first
    let exactMatch = products.find(p => p.title.toLowerCase() === searchLower);
    if (exactMatch) return exactMatch;

    // Contains match
    let containsMatch = products.find(p => p.title.toLowerCase().includes(searchLower));
    if (containsMatch) return containsMatch;

    // Word match
    const searchWords = searchLower.split(' ');
    let wordMatch = products.find(p => {
      const titleLower = p.title.toLowerCase();
      return searchWords.every(word => titleLower.includes(word));
    });
    if (wordMatch) return wordMatch;

    // Return first result as fallback
    return products[0];
  }

  function displayResults() {
    // Update summary
    foundCount.textContent = `${searchResults.length} found`;
    missingCount.textContent = `${missingCards.length} missing`;
    totalPrice.textContent = `£${totalCost.toFixed(2)} total`;

    // Enable/disable add all button
    addAllBtn.disabled = searchResults.length === 0;

    // Display found cards
    resultsGrid.innerHTML = '';
    searchResults.forEach((result, index) => {
      const cardElement = createCardElement(result, index);
      resultsGrid.appendChild(cardElement);
    });

    // Display missing cards
    if (missingCards.length > 0) {
      missingList.innerHTML = '';
      missingCards.forEach(card => {
        const missingElement = createMissingCardElement(card);
        missingList.appendChild(missingElement);
      });
      missingCardsSection.style.display = 'block';
    } else {
      missingCardsSection.style.display = 'none';
    }

    showResults();
  }

  function createCardElement(result, index) {
    const cardDiv = document.createElement('div');
    cardDiv.className = 'deckbuilder-card found';
    cardDiv.style.animationDelay = `${index * 0.1}s`;

    const totalPrice = (result.price * result.quantity).toFixed(2);

    cardDiv.innerHTML = `
      <div class="card-quantity">${result.quantity}x</div>
      ${result.image ? `<img src="${result.image}" alt="${result.title}" class="card-image">` : '<div class="card-image"></div>'}
      <div class="card-info">
        <h3>${result.title}</h3>
        <div class="card-price">£${result.price.toFixed(2)} each</div>
        <div class="card-variant-info">Total: £${totalPrice}</div>
        <div class="card-actions">
          <button type="button" class="btn btn-primary btn-small" onclick="addSingleCardToCart('${result.variantId}', ${result.quantity})">
            Add ${result.quantity} to Cart
          </button>
          <button type="button" class="btn btn-secondary btn-small" onclick="showAlternatives('${result.originalCardName}', ${index})">
            Alternatives
          </button>
          <a href="${result.url}" class="btn btn-secondary btn-small" target="_blank">View Product</a>
        </div>
      </div>
    `;

    return cardDiv;
  }

  function createMissingCardElement(card) {
    const cardDiv = document.createElement('div');
    cardDiv.className = 'missing-card-item';

    cardDiv.innerHTML = `
      <div class="card-name">${card.cardName}</div>
      <span class="card-quantity">${card.quantity}x</span>
    `;

    return cardDiv;
  }

  async function addAllFoundCardsToCart() {
    if (searchResults.length === 0) return;

    addAllBtn.disabled = true;
    addAllBtn.textContent = 'Adding to Cart...';

    try {
      // Add items one by one to avoid bulk cart issues
      let successCount = 0;
      
      for (const result of searchResults) {
        try {
          const formData = new FormData();
          formData.append('id', result.variantId);
          formData.append('quantity', result.quantity);

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            successCount++;
          } else {
            console.error(`Failed to add ${result.title}`);
          }
          
          // Small delay to prevent overwhelming the server
          await new Promise(resolve => setTimeout(resolve, 100));
        } catch (error) {
          console.error(`Error adding ${result.title}:`, error);
        }
      }

      if (successCount > 0) {
        addAllBtn.textContent = `Added ${successCount} Cards!`;
        addAllBtn.className = 'btn btn-success btn-large';
        
        // Update cart count and trigger notifications
        await updateCartCount();
        
        // Use standard Shopify cart notification
        if (window.cartNotification) {
          window.cartNotification.renderContents();
        }
      } else {
        throw new Error('No cards could be added to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error adding cards to cart. Please try again.');
      addAllBtn.disabled = false;
      addAllBtn.textContent = 'Add All Found Cards to Cart';
    }
  }

  // Function to update cart count
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Update cart count in various places
      const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, #sticky-cart-count, .cart-count-bubble');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });
      
      // Trigger cart update events
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      
      return cart;
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  // Global function for individual card add to cart
  window.addSingleCardToCart = async function(variantId, quantity) {
    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        // Update cart count and trigger notifications
        await updateCartCount();
        
        // Use standard Shopify cart notification
        if (window.cartNotification) {
          window.cartNotification.renderContents();
        }
      } else {
        const errorData = await response.text();
        console.error('Cart add error:', errorData);
        throw new Error('Failed to add item to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error adding card to cart. Please try again.');
    }
  };

  function showLoading() {
    loadingIndicator.style.display = 'block';
    resultsSection.style.display = 'none';
    searchBtn.disabled = true;
    searchBtn.textContent = 'Searching...';
  }

  function hideLoading() {
    loadingIndicator.style.display = 'none';
    searchBtn.disabled = false;
    searchBtn.textContent = 'Search Cards';
  }

  function showResults() {
    // Hide input section and show results
    inputSection.style.display = 'none';
    resultsSection.style.display = 'block';
  }

  function hideResults() {
    resultsSection.style.display = 'none';
    addAllBtn.disabled = true;
    addAllBtn.textContent = 'Add All Found Cards to Cart';
    addAllBtn.className = 'btn btn-success btn-large';
  }

  function showInputSection() {
    inputSection.style.display = 'block';
  }

  function hideInputSection() {
    inputSection.style.display = 'none';
  }

  // Initialize stats
  updateInputStats();

  // Sample deck list for demonstration
  const sampleDeck = `2 Island
3 Forest
Counterspell
Lightning Bolt
4 Llanowar Elves
Giant Growth`;

  // Add sample deck button for testing
  const sampleBtn = document.createElement('button');
  sampleBtn.textContent = 'Load Sample Deck';
  sampleBtn.className = 'btn btn-secondary';
  sampleBtn.addEventListener('click', function() {
    deckInput.value = sampleDeck;
    updateInputStats();
  });
  
  document.querySelector('.deckbuilder-actions').appendChild(sampleBtn);

  // Global function to show alternatives
  window.showAlternatives = async function(cardName, resultIndex) {
    const modal = document.getElementById('alternatives-modal');
    const title = document.getElementById('alternatives-title');
    const grid = document.getElementById('alternatives-grid');
    const loading = document.getElementById('alternatives-loading');
    
    title.textContent = `Alternatives for "${cardName}"`;
    modal.style.display = 'flex';
    loading.style.display = 'block';
    grid.innerHTML = '';
    
    try {
      const alternatives = await searchAlternatives(cardName);
      loading.style.display = 'none';
      
      if (alternatives.length > 0) {
        alternatives.forEach((alt, index) => {
          const altElement = createAlternativeElement(alt, cardName, resultIndex, index);
          grid.appendChild(altElement);
        });
      } else {
        grid.innerHTML = '<p style="text-align: center; padding: 2rem; color: rgba(var(--color-foreground), 0.6);">No alternatives found for this card.</p>';
      }
    } catch (error) {
      console.error('Error finding alternatives:', error);
      loading.style.display = 'none';
      grid.innerHTML = '<p style="text-align: center; padding: 2rem; color: #dc3545;">Error finding alternatives. Please try again.</p>';
    }
  };

  // Global function to close alternatives modal
  window.closeAlternativesModal = function() {
    document.getElementById('alternatives-modal').style.display = 'none';
  };

  // Global function to swap card
  window.swapCard = function(resultIndex, newProduct) {
    // Update the search result
    searchResults[resultIndex] = {
      ...searchResults[resultIndex],
      product: newProduct.product,
      variant: newProduct.variant,
      title: newProduct.title,
      price: newProduct.price,
      image: newProduct.image,
      url: newProduct.url,
      variantId: newProduct.variantId
    };
    
    // Recalculate total cost
    totalCost = searchResults.reduce((sum, result) => sum + (result.price * result.quantity), 0);
    
    // Update display
    displayResults();
    closeAlternativesModal();
  };

  async function searchAlternatives(cardName) {
    try {
      const vendorSelect = document.getElementById('vendor-select');
      const selectedCollection = vendorSelect.value;
      
      let searchQuery = encodeURIComponent(cardName);
      let searchUrl = `/search/suggest.json?q=${searchQuery}&resources[type]=product&resources[limit]=12`;

      const response = await fetch(searchUrl);
      const data = await response.json();

      if (data.resources && data.resources.results && data.resources.results.products && data.resources.results.products.length > 0) {
        let products = data.resources.results.products;
        
        // If collection is selected, filter products by collection
        if (selectedCollection) {
          products = products.filter(product => {
            return product.url && product.url.includes(`/collections/${selectedCollection}/`);
          });
        }
        
        // Process alternatives in parallel for speed
        const alternativePromises = products.slice(0, 6).map(async (product) => {
          try {
            const productResponse = await fetch(`/products/${product.handle}.js`);
            const productData = await productResponse.json();
            
            const availableVariant = productData.variants.find(v => v.available);
            if (availableVariant) {
              return {
                product: productData,
                variant: availableVariant,
                title: productData.title,
                price: availableVariant.price / 100,
                image: productData.featured_image,
                url: `/products/${productData.handle}`,
                variantId: availableVariant.id
              };
            }
            return null;
          } catch (e) {
            console.error('Error fetching product details:', e);
            return null;
          }
        });
        
        // Wait for all requests to complete
        const alternativeResults = await Promise.all(alternativePromises);
        
        // Filter out null results
        const alternatives = alternativeResults.filter(alt => alt !== null);
        
        return alternatives;
      }
      
      return [];
    } catch (error) {
      console.error('Error searching alternatives:', error);
      return [];
    }
  }

  function createAlternativeElement(alternative, originalCardName, resultIndex, index) {
    const altDiv = document.createElement('div');
    altDiv.className = 'alternative-card';
    altDiv.style.animationDelay = `${index * 0.1}s`;
    
    const quantity = searchResults[resultIndex].quantity;
    const totalPrice = (alternative.price * quantity).toFixed(2);

    altDiv.innerHTML = `
      ${alternative.image ? `<img src="${alternative.image}" alt="${alternative.title}" class="alternative-card-image">` : '<div class="alternative-card-image"></div>'}
      <h4>${alternative.title}</h4>
      <div class="alternative-card-price">£${alternative.price.toFixed(2)} each</div>
      <div class="alternative-card-variant">Total: £${totalPrice} (${quantity}x)</div>
      <div class="alternative-card-actions">
        <button type="button" class="btn btn-success btn-small" onclick="swapCard(${resultIndex}, ${JSON.stringify(alternative).replace(/"/g, '&quot;')})">
          Use This Card
        </button>
        <a href="${alternative.url}" class="btn btn-secondary btn-small" target="_blank">View</a>
      </div>
    `;

    return altDiv;
  }
});
